import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import tw, { css, styled } from 'twin.macro'

import qs from 'qs'
import Layout from '../../components/layout'
import Meta from '../../components/meta'
import { Link, graphql } from 'gatsby'
import filterLocale from '../../components/utils/filter-locale'
import SupportSearch from '../../components/support/support-search'
import Tabs from '../../components/support/tabs'
import {
	Combobox,
	ComboboxPopover,
	ComboboxList,
	ComboboxOption,
} from '@reach/combobox'
import { Menu, MenuItem, MenuList } from '@reach/menu-button'
import { useQuery } from '@apollo/react-hooks'
import { Lottie } from '@lottie'
import * as animationLoading from '../../animations/loading.json'
import Map from '../../components/map/dealer'
import { Mail, Phone, ChevronDown, Star, MapPin } from 'react-feather'
import { StyledComboboxInput, SelectButton } from '../../components/form/styles'
// import { DealerCard, useAddressSearch } from '../../pages/find-a-dealer.en-ZA'
import { FIND_DEALERS } from '../../app/schema/dealer'

const ContentsSection = tw.section`w-full bg-gray-200`
const ContentsContainer = tw.div`w-95 md:w-11/12 bg-white py-10 px-4 md:px-10 mx-auto border-l border-r border-gray-300 border-b rounded-b-lg mb-16`

const TextsImageContainer = tw.div`flex flex-col md:flex-row mb-10`
const Header = tw.h2`font-display text-3xl md:text-4xl font-bold mb-6`
const HeaderSubText = styled.p`
	${tw`font-display text-base md:text-lg mb-4`}

	span {
		${tw`underline text-blue-500`}
	}

	> a {
		${tw`underline text-blue-500 hover:no-underline font-display`}
	}
`

const SearchContainer = styled.div`
	@media (min-width: 525px) {
		${tw`w-11/12`}
	}
	${tw`flex flex-col sm:flex-row w-full md:w-10/12 xl:w-11/12 xxl:w-10/12 mt-8 md:mt-12 mb-8 mx-auto`}
	.search-combobox {
		${tw`relative flex w-full sm:w-4/6 md:w-4/6 lg:w-4/6`}
		${tw`border-0 p-0 m-0`}
    input {
			${tw`flex w-full appearance-none py-2 pl-8 pr-4`}
		}
	}
	.search-type {
		${tw`w-full sm:w-2/6 md:w-2/6 lg:w-2/6 ml-0 sm:ml-2 md:ml-2 lg:ml-2`}
	}
`

const You = styled.span`
	${tw`absolute left-0 top-0 flex`}
	height: 40px;
	width: 40px;
	svg {
		margin: auto;
		stroke: #22292f;
		path {
			stroke: #22292f;
		}
	}
`

const Them = styled.span`
	${tw`absolute flex`}
	height: 40px;
	width: 40px;
	left: -1px;
	top: -1px;
	svg {
		margin: auto;
		stroke: #22292f;
		path {
			stroke: #22292f;
		}
	}
`

const MapResultsContainer = styled.div`
	min-width: 240px;
	@media (min-width: 525px) {
		${tw`w-11/12`}
	}
	${tw`flex flex-col lg:flex-row md:w-10/12 xl:w-11/12 xxl:w-10/12 mx-auto`}

	@media (min-width: 1024px) and (max-width: 1279px) {
		${tw`w-10/12`}
	}
`
const MapWrap = styled.div`
	${tw`flex w-full`}
	.mapbox {
		${tw`border-2 border-white`}
		height: 400px;
		min-height: 300px;
		max-height: 400px;

		@media (max-width: 767px) {
			height: 250px;
			min-height: 250px;
			max-height: 300px;
		}
	}
`
const ResultsCtaContainer = styled.div`
	${tw`flex flex-col md:flex-row lg:flex-col w-full ml-0 pl-0 xl:ml-4 xl:pl-6 md:mr-4 lg:mr-0`}

	@media(min-width:1024px) and (max-width:1279px) {
		${tw`ml-4 pl-4`}
	}
	.loading {
		svg {
			${tw`stroke-current text-white`}
			path {
				${tw`stroke-current text-white`}
			}
		}
	}
`
const ButtonsContainer = styled.div`
	${tw`flex flex-row md:w-6/12 lg:w-full md:items-center lg:items-end md:ml-3 mt-3 md:mt-0 lg:ml-0`}
	height: 50%;

	@media (max-width: 1023px) {
		${tw`h-auto`}
	}
`
const Call = styled.a`
	@media (min-width: 525px) {
		${tw`p-4`}
	}
	${tw`flex flex-col w-6/12 mr-4 h-full items-center justify-center font-display font-bold text-xl border-2 border-yellow-500 rounded-lg bg-white p-2 md:p-0`}
	transition: .2s ease-in-out;
	&:hover {
		background-color: rgba(255, 255, 255, 0.6);
		svg {
			${tw`stroke-current text-white`}
		}
	}
	svg {
		${tw`mb-2 `}
	}
	max-height: 150px;
`
const Email = styled(Call)`
	${tw`mr-0 ml-4`}
`
const FindRepairerContainer = tw.div`flex flex-col flex-wrap py-6 md:py-10 px-3 md:px-12 bg-gray-100`
const TextsContainer = tw.div`flex flex-col w-full mr-0 md:mr-4`

const DealersContainer = tw.div`mt-12`
const EliteParagraph = tw.p`font-display text-center mb-6`
const EliteItemImage = styled.img`
	@media (min-width: 525px) {
		${tw`w-8/12`}
	}
	${tw`mb-6 w-6/12 lg:w-auto mx-auto`}
	@media (min-width: 1400px) {
		width: 320px;
	}
`
const ContentLink = styled(Link)`
	${tw`underline text-blue-500 hover:no-underline font-display`}
`
const LogoContainer = styled.div`
	${tw`flex flex-col md:flex-row items-center justify-center mt-4`}

	> img {
		${tw`w-auto md:w-6/12 px-4`}
		max-width: 250px;
	}
`
const DealerLogoContainer = styled.div`
	${tw`flex flex-col md:flex-row items-center justify-center mt-12 w-full mx-auto flex-wrap`}
	a {
		${tw`w-full md:w-1/3 lg:w-1/4 px-3 mb-4`}
		max-width: 300px;
	}
`

/**
 * Find a Dealer - Page
 * @param {*} props
 * @param {object} props.data - static query data
 * @see supportFaqQuery
 */
const FindDealer = ({
	data: { finddealer, authorised, authdealers },
	...props
}) => {
	const hs = props.location.hash
	const hash = hs.length && hs[0] == '#' ? hs.replace(/^#/, '') : ''
	const ps = props.location.search
	const params =
		ps.length && ps[0] == '?' ? qs.parse(ps.replace(/^\?/, '')) : ''
	const hasType = Boolean(params && params.type)
	const locale = 'en-ZA'
	const [{ node }] = filterLocale(finddealer.edges, locale)
	const [{ node: auth }] = filterLocale(authorised.edges, locale)
	const [{ node: authdeal }] = filterLocale(authdealers.edges, locale)

	const { seoTitle, seoKeywords, seoDescription } = node

	const [searchTerm, setSearchTerm] = useState('')
	const [type, setType] = useState(
		hasType ? [params.type, params.type] : ['Elite Dealer', 'elite']
	)
	// const addresses = useAddressSearch(searchTerm)
	const [consumerCoordinates, setConsumerCoordinates] = useState([])
	const handleSearchTermChange = event => {
		setSearchTerm(event.target.value)
	}
	const queryString = query => JSON.stringify(query)
	const { loading, data, refetch } = useQuery(FIND_DEALERS, {
		variables: {
			query: queryString({ type: type[1], status: 'active' }),
			coordinates: consumerCoordinates,
			maxDistance: 400000,
			limit: 2,
		},
	})
	const allDealers =
		data && data.dealersByDistance ? data.dealersByDistance : []
	const hasOne = allDealers.length === 1
	const hasTwo = allDealers.length === 2
	const oneOrNone = hasTwo
		? allDealers && allDealers[0] && allDealers[0].name && [allDealers[0]]
		: hasOne
		? allDealers && allDealers[0] && allDealers[0].name && [allDealers[0]]
		: []
	const inCluster =
		(hasTwo && allDealers[1].meta.distance <= 6000) ||
		(hasOne && allDealers[0].meta.distance <= 6000)
	const dealers = inCluster ? allDealers : oneOrNone
	const [dealer, setDealer] = useState({})
	const [isSelected, setIsSelected] = useState(0)
	const handleSelectDealer = async index => {
		setDealer(dealers[index])
		setIsSelected(index)
	}
	const handleRefetch = async query => {
		return await refetch({
			query: queryString(query),
			coordinates: consumerCoordinates,
			limit: 2,
		})
	}
	// const getConsumerCoordinates = async address => {
	// 	const results = addresses && addresses.features
	// 	const coordinates = results
	// 		.filter(x => x.place_name === address)
	// 		.map(x => x.geometry.coordinates)
	// 		.reduce((acc, val) => acc.concat(val), [])
	// 	setConsumerCoordinates(coordinates)
	// 	await handleRefetch({ type: type[1], status: 'active' })
	// }
	useEffect(() => {
		let isFresh = true
		const selectDealer = async () => {
			setDealer(dealers[0])
			setIsSelected(0)
		}
		selectDealer()
		return () => (isFresh = false)
	}, [dealers])

	return (
		<Layout>
			<Meta
				title={seoTitle}
				keywords={seoKeywords}
				description={seoDescription}
				lang={locale}
			/>
			<SupportSearch />
			<Tabs locale={locale} />
			<ContentsSection>
				<ContentsContainer>
					<TextsImageContainer>
						<TextsContainer>
							<Header>Elite Dealer Search</Header>
							<HeaderSubText>
								Are you dealing with an Authorised Maytronics Dealer? Look for
								these logos for certainty.
							</HeaderSubText>

							<LogoContainer>
								{auth.items.map((x, i) => {
									return (
										<img
											key={i}
											src={x.image.file.url}
											alt="Authorised Maytronics Dealer"
										/>
									)
								})}
							</LogoContainer>
						</TextsContainer>
					</TextsImageContainer>
					{/* <div
						id="FIND-A-DEALER"
						tw="flex flex-col lg:flex-row w-full bg-gray-400 p-2"
					>
						<div
							id="MAP-COMPONENT"
							tw="flex flex-col w-full lg:w-1/2 lg:mr-2 mb-2 lg:mb-0"
						>
							<div id="INPUT-WRAP" tw="flex flex-col w-full relative">
								<Combobox
									onSelect={option => {
										if (option === 'No results found') return
										getConsumerCoordinates(option)
									}}
								>
									<You aria-hidden>
										<Star size={20} css={tw`fill-current text-yellow-500`} />
									</You>
									<StyledComboboxInput
										tw="flex w-full appearance-none py-2 pl-8 pr-4"
										type="text"
										placeholder="Your Street Address"
										onChange={handleSearchTermChange}
										css={tw`border-white`}
									/>
									{addresses && (
										<ComboboxPopover className="shadow-popup">
											{addresses &&
											addresses.features &&
											addresses.features.length > 0 ? (
												<ComboboxList
													className="contrast-dropdown"
													css={tw`border-white`}
												>
													{addresses &&
														addresses.features.map(place => {
															return (
																<ComboboxOption
																	key={place.id}
																	value={place.place_name}
																/>
															)
														})}
												</ComboboxList>
											) : (
												<ComboboxList
													className="contrast-dropdown"
													css={tw`border-white`}
												>
													<ComboboxOption value={'No results found'} />
												</ComboboxList>
											)}
										</ComboboxPopover>
									)}
								</Combobox>
								<Menu>
									<SelectButton
										className="search-type"
										css={tw`border-white relative`}
										disabled={`loading`}
									>
										<Them aria-hidden>
											<MapPin
												size={20}
												css={tw`fill-current text-blue-500`}
											/>
										</Them>
										{type[0] ? (
											<span className="tag" css={tw`ml-4`}>
												{type[0]}
											</span>
										) : (
											'Elite Dealer'
										)}
										<span aria-hidden css={tw`ml-auto`}>
											<ChevronDown size={20} />
										</span>
									</SelectButton>
									<MenuList
										className="contrast-dropdown"
										css={tw`border-white`}
									>
										<MenuItem
											onSelect={() => {
												setType(['Elite Dealer', 'elite'])
												handleRefetch({ type: 'elite', status: 'active' })
											}}
										>
											Elite Dealer
										</MenuItem>
										<MenuItem
											onSelect={() => {
												setType(['Robotic Repairs', 'roboticrepairs'])
												handleRefetch({
													type: 'roboticrepairs',
													status: 'active',
												})
											}}
										>
											Robotic Repairs
										</MenuItem>
										<MenuItem
											onSelect={() => {
												setType(['Spare Parts', 'elite'])
												handleRefetch({ type: 'elite', status: 'active' })
											}}
										>
											Spare Parts
										</MenuItem>
										<MenuItem
											onSelect={() => {
												setType(['Mineral Swim', 'mineralswim'])
												handleRefetch({ type: 'mineralswim', status: 'active' })
											}}
										>
											Mineral Swim
										</MenuItem>
										<MenuItem
											onSelect={() => {
												setType([
													'Water Treatment Repairs',
													'watertreatmentrepairs',
												])
												handleRefetch({
													type: 'watertreatmentrepairs',
													status: 'active',
												})
											}}
										>
											Water Treatment Repairs
										</MenuItem>
										<MenuItem
											onSelect={() => {
												setType(['Pool Builder', 'elitebuilder'])
												handleRefetch({
													type: 'elitebuilder',
													status: 'active',
												})
											}}
										>
											Pool Builder
										</MenuItem>
									</MenuList>
								</Menu>
							</div>
							<MapWrap id="MAP-WRAP">
								<Map
									css={tw`bg-white`}
									consumer={consumerCoordinates}
									dealers={dealers}
									loading={loading}
									onSelect={handleSelectDealer}
									isSelected={isSelected}
								/>
							</MapWrap>
						</div>
						<div
							id="RESULT-COMPONENT"
							tw="flex w-full items-center justify-center lg:w-1/2"
						>
							{loading ? (
								<Lottie
									width="60px"
									height="60px"
									className="lottie-container loading"
									css={tw`mx-auto mt-1 mb-3 text-blue-500 fill-current`}
									config={{
										animationData: animationLoading.default,
										loop: true,
										autoplay: true,
										renderer: 'svg',
									}}
									aria-hidden
								/>
							) : (
								data &&
								data.dealersByDistance && (
									<DealerCard
										dealer={dealer && dealer.name ? dealer : dealers[0]}
									/>
								)
							)}
						</div>
					</div> */}

					<DealersContainer>
						<HeaderSubText>
							Maytronics Authorised Dealers are trained and local to you to
							provide support and service for your purchase of a Maytronics
							Product. Maytronics Authorised Dealers also have access to
							extended warranty. Only dealers that display the logo below meet
							Maytronics stringent requirements to be authorised. If you are not
							sure if a Dealer is authorised, please contact us direct on{' '}
							<a href="tel:1300693657">1300 693 657</a> or 
							<a href="mailto:infoau@maytronics.com">infoau@maytronics.com</a>.
						</HeaderSubText>
						<HeaderSubText>
							In addition to our Elite Dealers, we also authorise the following
							distribution networks
						</HeaderSubText>

						<DealerLogoContainer>
							{authdeal.items.map((x, i) => {
								return (
									<a
										key={i}
										href={x.url}
										target="_blank"
										rel="noopener noreferrer"
									>
										<img
											src={x.image.file.url}
											alt="Maytronics Authorised Dealers"
										/>
									</a>
								)
							})}
						</DealerLogoContainer>
					</DealersContainer>
				</ContentsContainer>
			</ContentsSection>
		</Layout>
	)
}

/**
 * Page Query
 * @static graphql query from Contentful
 */
export const supportFaqQuery = graphql`
	query findDealerQueryZa {
		finddealer: allContentfulPage(
			filter: { contentful_id: { eq: "6LAjCqRqIKB2gF4WIQdY1G" } }
		) {
			edges {
				node {
					seoTitle
					seoKeywords
					seoDescription
					node_locale
					slug
					body {
						json
					}
				}
			}
		}
		authorised: allContentfulFeaturedItems(
			filter: { contentful_id: { eq: "4nSUnNIpIcguqEKR16Pevu" } }
		) {
			edges {
				node {
					items {
						url
						image {
							file {
								url
							}
						}
					}
					node_locale
				}
			}
		}
		authdealers: allContentfulFeaturedItems(
			filter: { contentful_id: { eq: "50phjcIV3OsUVeAvJXDGyG" } }
		) {
			edges {
				node {
					items {
						url
						image {
							file {
								url
							}
						}
					}
					node_locale
				}
			}
		}
	}
`

FindDealer.propTypes = {
	data: PropTypes.objectOf({
		finddealer: PropTypes.any,
		authorised: PropTypes.any,
		authdealers: PropTypes.any,
	}),
}

export default FindDealer
